import { render, staticRenderFns } from "./FareWellPage.vue?vue&type=template&id=29a4dae9&"
import script from "./FareWellPage.vue?vue&type=script&lang=js&"
export * from "./FareWellPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports